import { syncNationalRouteStops, type NationalRouteStop } from "./national-route"

type WorkLine = "nacional" | "internacional" | "batea"

type ShipmentProductInput = {
  productId: string
  quantity?: string | null
  weightKg?: string | null
  notes?: string | null
}

export interface ShipmentPayloadInput {
  clientId: string
  cargoTypeId?: string
  productId?: string
  externalId: string
  cargoValue: string
  workLine: WorkLine | ""
  status: string
  senderId: string
  recipientId: string
  scheduledOriginArrivalAt: string
  scheduledDestinationArrivalAt: string
  notes: string
  billingNotes?: string
  billingStatus?: string | null
  deliveryNoteNumber: string
  loadingWeightKg?: string
  unloadingWeightKg?: string
  deliveryNoteStatus?: string
  loadingWindow: string
  finalDestinationId: string
  routeId: string
  routeStops: NationalRouteStop[]
  isRouted: boolean
  isMultiLeg?: boolean
  billingTags: string[]
  internationalIds: string[]
  confirmInternationalIdsDeletion: boolean
  mobileId?: string
  products?: ShipmentProductInput[]
}

export function buildShipmentPayload(form: ShipmentPayloadInput, isEdit = false) {
  const nationalRouteStops = form.workLine === "nacional" && form.senderId && form.recipientId
    ? syncNationalRouteStops(form.senderId, form.recipientId, form.routeStops)
    : undefined

  const products = form.products !== undefined
    ? form.products.map(product => ({
        productId: product.productId,
        quantity:  product.quantity || null,
        weightKg:  product.weightKg || null,
        notes:     product.notes || null,
      }))
    : form.productId
      ? [{ productId: form.productId }]
      : undefined

  return {
    clientId:    form.clientId || null,
    cargoTypeId: form.cargoTypeId || null,
    senderId:    form.senderId || null,
    recipientId: form.recipientId || null,
    externalId:  form.externalId || null,
    cargoValue:  form.workLine === "internacional" ? (form.cargoValue || null) : null,
    workLine:    (form.workLine || null) as WorkLine | null,
    status:      isEdit ? form.status : "en_planificacion",
    notes:       form.notes || null,
    billingNotes: form.billingNotes || null,
    billingStatus: form.billingStatus ?? null,
    deliveryNoteNumber: form.deliveryNoteNumber || null,
    loadingWeightKg: form.loadingWeightKg || null,
    unloadingWeightKg: form.unloadingWeightKg || null,
    deliveryNoteStatus: form.deliveryNoteStatus,
    scheduledOriginArrivalAt: form.scheduledOriginArrivalAt
      ? new Date(form.scheduledOriginArrivalAt).toISOString()
      : null,
    scheduledDestinationArrivalAt: form.scheduledDestinationArrivalAt
      ? new Date(form.scheduledDestinationArrivalAt).toISOString()
      : null,
    loadingWindow: form.workLine === "batea" ? (form.loadingWindow || null) : null,
    finalDestinationId: form.workLine === "batea" ? (form.finalDestinationId || null) : null,
    routeId: form.workLine === "nacional" ? (form.routeId || null) : null,
    routeStops: nationalRouteStops,
    mobileId: nationalRouteStops?.length ? (form.mobileId || null) : undefined,
    isRouted: form.isRouted,
    isMultiLeg: form.isMultiLeg,
    billingTags: form.billingTags,
    internationalIds: form.workLine === "internacional" ? form.internationalIds : [],
    confirmInternationalIdsDeletion: form.confirmInternationalIdsDeletion,
    products,
  }
}
